import ViewFileModal from "_components/Modals/ViewFileModal";
import React from "react";
import { useState } from "react";

export type PortfolioImage = {
  name: string;
  type: string;
  urls: {
    originalUrl: string;
    thumbnailUrl: string;
  };
};

type Props = {
  image: PortfolioImage;
};

export default function PortfolioImageContainer({
  image: {
    name,
    urls: { originalUrl, thumbnailUrl },
    type,
  },
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full flex justify-center items-center">
      <ViewFileModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        file={{ name, url: originalUrl, type: type.split("/")[1] }}
      />
      <div
        className="bg-[#F5F5F5] w-fit h-fit p-1 lg:p-2 cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <img
          src={thumbnailUrl}
          alt="Work history item"
          className="h-[180px] w-[200px] object-contain"
        />
      </div>
    </div>
  );
}
